import { performDeleteRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';

export const deleteExternalLink = (
	cloudId: string,
	projectId: string,
	linkId: string, // eslint-disable-next-line @typescript-eslint/no-explicit-any
): Promise<Record<any, any>> => {
	const uri = `/gateway/api/jira/help-sandook/cloudid/${cloudId}/api/v1/external-links/project/${projectId}/link/${linkId}`;

	return performDeleteRequest(uri);
};
